// extracted by mini-css-extract-plugin
module.exports = {"cart":"_3Tbel","cart_placeholder":"_1Zj0s","active":"_1LFlO","button":"_3UACR","line":"gznf8","icon":"_1xbPh","total":"XviFM","summ":"_2J-48"};